"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventMessage = exports.getLogLevel = exports.getLogLevels = exports.LogLevel = exports.getEventGroup = exports.ReportEventGroup = exports.ReportEvent = exports.Qualify = void 0;
var Qualify;
(function (Qualify) {
    Qualify[Qualify["NEW"] = 1] = "NEW";
    Qualify[Qualify["RESTORE"] = 3] = "RESTORE";
})(Qualify = exports.Qualify || (exports.Qualify = {}));
var ReportEvent;
(function (ReportEvent) {
    ReportEvent[ReportEvent["SECURITY_MEDICAL_ALARM"] = 100] = "SECURITY_MEDICAL_ALARM";
    ReportEvent[ReportEvent["SECURITY_PERSONAL_EMERGENCY"] = 101] = "SECURITY_PERSONAL_EMERGENCY";
    ReportEvent[ReportEvent["SECURITY_FAIL_TO_REPORT_IN"] = 102] = "SECURITY_FAIL_TO_REPORT_IN";
    ReportEvent[ReportEvent["SECURITY_FIRE_ALARM"] = 110] = "SECURITY_FIRE_ALARM";
    ReportEvent[ReportEvent["SECURITY_SMOKE_ALARM"] = 111] = "SECURITY_SMOKE_ALARM";
    ReportEvent[ReportEvent["SECURITY_COMBUSTION_ALARM"] = 112] = "SECURITY_COMBUSTION_ALARM";
    ReportEvent[ReportEvent["SECURITY_WATER_FLOW_ALARM"] = 113] = "SECURITY_WATER_FLOW_ALARM";
    ReportEvent[ReportEvent["SECURITY_HEAT_ALARM"] = 114] = "SECURITY_HEAT_ALARM";
    ReportEvent[ReportEvent["SECURITY_PULL_STATION_ALARM"] = 115] = "SECURITY_PULL_STATION_ALARM";
    ReportEvent[ReportEvent["SECURITY_DUCT_ALARM"] = 116] = "SECURITY_DUCT_ALARM";
    ReportEvent[ReportEvent["SECURITY_FLAME_ALARM"] = 117] = "SECURITY_FLAME_ALARM";
    ReportEvent[ReportEvent["SECURITY_NEAR_ALARM"] = 118] = "SECURITY_NEAR_ALARM";
    ReportEvent[ReportEvent["SECURITY_PANIC_ALARM"] = 120] = "SECURITY_PANIC_ALARM";
    ReportEvent[ReportEvent["SECURITY_DURESS_PANIC_ALARM"] = 121] = "SECURITY_DURESS_PANIC_ALARM";
    ReportEvent[ReportEvent["SECURITY_SILENT_PANIC_ALARM"] = 122] = "SECURITY_SILENT_PANIC_ALARM";
    ReportEvent[ReportEvent["SECURITY_AUDIBLE_PANIC_ALARM"] = 123] = "SECURITY_AUDIBLE_PANIC_ALARM";
    ReportEvent[ReportEvent["SECURITY_DURESS_ACCESS_GRANTED_ALARM"] = 124] = "SECURITY_DURESS_ACCESS_GRANTED_ALARM";
    ReportEvent[ReportEvent["SECURITY_DURESS_EGRESS_GRANTED_ALARM"] = 125] = "SECURITY_DURESS_EGRESS_GRANTED_ALARM";
    ReportEvent[ReportEvent["SECURITY_BURGLARY_ALARM"] = 130] = "SECURITY_BURGLARY_ALARM";
    ReportEvent[ReportEvent["SECURITY_PERIMETER_ALARM"] = 131] = "SECURITY_PERIMETER_ALARM";
    ReportEvent[ReportEvent["SECURITY_INTERIOR_ALARM"] = 132] = "SECURITY_INTERIOR_ALARM";
    ReportEvent[ReportEvent["SECURITY_24_HOUR_SAFE_ALARM"] = 133] = "SECURITY_24_HOUR_SAFE_ALARM";
    ReportEvent[ReportEvent["SECURITY_ENTRY_EXIT_ALARM"] = 134] = "SECURITY_ENTRY_EXIT_ALARM";
    ReportEvent[ReportEvent["SECURITY_DAY_NIGHT_ALARM"] = 135] = "SECURITY_DAY_NIGHT_ALARM";
    ReportEvent[ReportEvent["SECURITY_OUTDOOR_ALARM"] = 136] = "SECURITY_OUTDOOR_ALARM";
    ReportEvent[ReportEvent["SECURITY_TAMPER_ALARM"] = 137] = "SECURITY_TAMPER_ALARM";
    ReportEvent[ReportEvent["SECURITY_NEAR_ALARM_"] = 138] = "SECURITY_NEAR_ALARM_";
    ReportEvent[ReportEvent["SECURITY_INTRUSION_VERIFIER"] = 139] = "SECURITY_INTRUSION_VERIFIER";
    ReportEvent[ReportEvent["SECURITY_GENERAL_ALARM"] = 140] = "SECURITY_GENERAL_ALARM";
    ReportEvent[ReportEvent["SECURITY_POLLING_LOOP_OPEN"] = 141] = "SECURITY_POLLING_LOOP_OPEN";
    ReportEvent[ReportEvent["SECURITY_ZONE_TROUBLE"] = 142] = "SECURITY_ZONE_TROUBLE";
    ReportEvent[ReportEvent["SECURITY_EXPANSION_MODULE_FAILURE"] = 143] = "SECURITY_EXPANSION_MODULE_FAILURE";
    ReportEvent[ReportEvent["SECURITY_ZONE_TAMPER"] = 144] = "SECURITY_ZONE_TAMPER";
    ReportEvent[ReportEvent["SECURITY_EXPANSION_MODULE_TAMPER"] = 145] = "SECURITY_EXPANSION_MODULE_TAMPER";
    ReportEvent[ReportEvent["SECURITY_SILENT_BURGLARY"] = 146] = "SECURITY_SILENT_BURGLARY";
    ReportEvent[ReportEvent["SECURITY_SENSOR_SUPERVISION_FAILURE"] = 147] = "SECURITY_SENSOR_SUPERVISION_FAILURE";
    ReportEvent[ReportEvent["SECURITY_24_HOUR_NON_BURGLARY"] = 150] = "SECURITY_24_HOUR_NON_BURGLARY";
    ReportEvent[ReportEvent["SECURITY_GAS_DETECTED"] = 151] = "SECURITY_GAS_DETECTED";
    ReportEvent[ReportEvent["SECURITY_REFRIGERATION"] = 152] = "SECURITY_REFRIGERATION";
    ReportEvent[ReportEvent["SECURITY_LOSS_OF_HEAT"] = 153] = "SECURITY_LOSS_OF_HEAT";
    ReportEvent[ReportEvent["SECURITY_WATER_LEAKAGE"] = 154] = "SECURITY_WATER_LEAKAGE";
    ReportEvent[ReportEvent["SECURITY_FOIL_BREAK"] = 155] = "SECURITY_FOIL_BREAK";
    ReportEvent[ReportEvent["SECURITY_DAY_TROUBLE"] = 156] = "SECURITY_DAY_TROUBLE";
    ReportEvent[ReportEvent["SECURITY_LOW_BOTTLED_GAS_LEVEL"] = 157] = "SECURITY_LOW_BOTTLED_GAS_LEVEL";
    ReportEvent[ReportEvent["SECURITY_HIGH_TEMP"] = 158] = "SECURITY_HIGH_TEMP";
    ReportEvent[ReportEvent["SECURITY_LOW_TEMP"] = 159] = "SECURITY_LOW_TEMP";
    ReportEvent[ReportEvent["SECURITY_LOSS_OF_AIR_FLOW"] = 161] = "SECURITY_LOSS_OF_AIR_FLOW";
    ReportEvent[ReportEvent["SECURITY_CARBON_MONOXIDE_DETECTED"] = 162] = "SECURITY_CARBON_MONOXIDE_DETECTED";
    ReportEvent[ReportEvent["SECURITY_TANK_LEVEL"] = 163] = "SECURITY_TANK_LEVEL";
    ReportEvent[ReportEvent["SECURITY_SYSTEM_TROUBLE"] = 300] = "SECURITY_SYSTEM_TROUBLE";
    ReportEvent[ReportEvent["SECURITY_PRIMARY_AC_LOSS"] = 301] = "SECURITY_PRIMARY_AC_LOSS";
    ReportEvent[ReportEvent["SECURITY_LOW_SYSTEM_BATTERY"] = 302] = "SECURITY_LOW_SYSTEM_BATTERY";
    ReportEvent[ReportEvent["SECURITY_SOUNDER_RELAY_TROUBLE"] = 320] = "SECURITY_SOUNDER_RELAY_TROUBLE";
    ReportEvent[ReportEvent["SECURITY_BELL_1_TROUBLE"] = 321] = "SECURITY_BELL_1_TROUBLE";
    ReportEvent[ReportEvent["SECURITY_ATS_COMMUNICATION_TROUBLE"] = 350] = "SECURITY_ATS_COMMUNICATION_TROUBLE";
    ReportEvent[ReportEvent["SECURITY_PROGRAM_CHANGED"] = 306] = "SECURITY_PROGRAM_CHANGED";
    ReportEvent[ReportEvent["SECURITY_ARMED_DISARMED"] = 401] = "SECURITY_ARMED_DISARMED";
    ReportEvent[ReportEvent["SECURITY_FAILED_TO_ARM"] = 454] = "SECURITY_FAILED_TO_ARM";
    ReportEvent[ReportEvent["SECURITY_FAILED_TO_DISARM"] = 453] = "SECURITY_FAILED_TO_DISARM";
    ReportEvent[ReportEvent["SECURITY_PARTIAL_ARMED_DISARMED"] = 456] = "SECURITY_PARTIAL_ARMED_DISARMED";
    ReportEvent[ReportEvent["SECURITY_TROUBLE_ACK"] = 1005] = "SECURITY_TROUBLE_ACK";
    ReportEvent[ReportEvent["ADDITIONAL_USER_EVENTS"] = 1100] = "ADDITIONAL_USER_EVENTS";
    ReportEvent[ReportEvent["USER_ADDED"] = 1101] = "USER_ADDED";
    ReportEvent[ReportEvent["USER_REMOVED"] = 1102] = "USER_REMOVED";
    ReportEvent[ReportEvent["USER_MODIFIED"] = 1103] = "USER_MODIFIED";
    ReportEvent[ReportEvent["RESERVED_1104"] = 1104] = "RESERVED_1104";
    ReportEvent[ReportEvent["LOCAL_USER_LOGIN_SUCCESSFUL"] = 1105] = "LOCAL_USER_LOGIN_SUCCESSFUL";
    ReportEvent[ReportEvent["LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_WRONG_PASSWORD"] = 1106] = "LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_WRONG_PASSWORD";
    ReportEvent[ReportEvent["LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_DOES_NOT_HAVE_PASSWORD_ON_A_DATABASE"] = 1107] = "LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_DOES_NOT_HAVE_PASSWORD_ON_A_DATABASE";
    ReportEvent[ReportEvent["LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_UNKNOWN_USER"] = 1108] = "LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_UNKNOWN_USER";
    ReportEvent[ReportEvent["LOCAL_USER_LOGIN_INPUT_DISABLED_BECAUSE_OF_INVALID_ATTEMPTS"] = 1109] = "LOCAL_USER_LOGIN_INPUT_DISABLED_BECAUSE_OF_INVALID_ATTEMPTS";
    ReportEvent[ReportEvent["CARD_AUTHORIZATION_FAILURE_CARD_NOT_FOUND"] = 1120] = "CARD_AUTHORIZATION_FAILURE_CARD_NOT_FOUND";
    ReportEvent[ReportEvent["CARD_AUTHORIZATION_FAILURE_INVALID_PIN"] = 1121] = "CARD_AUTHORIZATION_FAILURE_INVALID_PIN";
    ReportEvent[ReportEvent["PIN_USER_AUTHORIZATION_FAILURE_INVALID_PIN"] = 1122] = "PIN_USER_AUTHORIZATION_FAILURE_INVALID_PIN";
    ReportEvent[ReportEvent["CARD_AUTHROIZATION_SUCCESSFUL"] = 1123] = "CARD_AUTHROIZATION_SUCCESSFUL";
    ReportEvent[ReportEvent["PIN_USER_AUTHROIZATION_SUCCESSFUL"] = 1124] = "PIN_USER_AUTHROIZATION_SUCCESSFUL";
    ReportEvent[ReportEvent["USER_LOGICAL_KEY_ADDED"] = 1125] = "USER_LOGICAL_KEY_ADDED";
    ReportEvent[ReportEvent["USER_LOGICAL_KEY_REMOVED"] = 1126] = "USER_LOGICAL_KEY_REMOVED";
    ReportEvent[ReportEvent["USER_LOGICAL_KEY_MODIFIED"] = 1127] = "USER_LOGICAL_KEY_MODIFIED";
    ReportEvent[ReportEvent["CLOUD_EVENTS"] = 1200] = "CLOUD_EVENTS";
    ReportEvent[ReportEvent["CLOUD_SETTINGS_CHANGED"] = 1201] = "CLOUD_SETTINGS_CHANGED";
    ReportEvent[ReportEvent["SUCCESSFULLY_CONNECTED_TO_CLOUD"] = 1202] = "SUCCESSFULLY_CONNECTED_TO_CLOUD";
    ReportEvent[ReportEvent["CLOUD_CONNECTION_CLOSED"] = 1203] = "CLOUD_CONNECTION_CLOSED";
    ReportEvent[ReportEvent["CLOUD_CONNECTION_ERROR"] = 1204] = "CLOUD_CONNECTION_ERROR";
    ReportEvent[ReportEvent["CLOUD_CONFIGURATION_MISSING"] = 1205] = "CLOUD_CONFIGURATION_MISSING";
    ReportEvent[ReportEvent["CLOUD_CONNECTION_OFFLINE"] = 1206] = "CLOUD_CONNECTION_OFFLINE";
    ReportEvent[ReportEvent["CLOUD_TOKEN_PUBLIC_KEYS_URL_CHANGED"] = 1207] = "CLOUD_TOKEN_PUBLIC_KEYS_URL_CHANGED";
    ReportEvent[ReportEvent["REMOTE_REPORTING_SETTINGS_CHANGED"] = 1350] = "REMOTE_REPORTING_SETTINGS_CHANGED";
    ReportEvent[ReportEvent["UNIT_EVENTS"] = 1400] = "UNIT_EVENTS";
    ReportEvent[ReportEvent["UNIT_CREATED"] = 1401] = "UNIT_CREATED";
    ReportEvent[ReportEvent["UNIT_SETTINGS_CHANGED"] = 1402] = "UNIT_SETTINGS_CHANGED";
    ReportEvent[ReportEvent["UNIT_DELETED"] = 1403] = "UNIT_DELETED";
    ReportEvent[ReportEvent["USER_ASSIGNED_TO_UNIT"] = 1404] = "USER_ASSIGNED_TO_UNIT";
    ReportEvent[ReportEvent["USER_UNASSIGNED_FROM_UNIT"] = 1405] = "USER_UNASSIGNED_FROM_UNIT";
    ReportEvent[ReportEvent["SW_UPDATE_STARTED"] = 1506] = "SW_UPDATE_STARTED";
    ReportEvent[ReportEvent["RED_EVENT"] = 2000] = "RED_EVENT";
    ReportEvent[ReportEvent["RED_NODE_DOOR_OPENED"] = 2001] = "RED_NODE_DOOR_OPENED";
    ReportEvent[ReportEvent["RED_NODE_DOOR_CLOSED"] = 2002] = "RED_NODE_DOOR_CLOSED";
    ReportEvent[ReportEvent["RED_NODE_DOOR_UNLOCKED"] = 2003] = "RED_NODE_DOOR_UNLOCKED";
    ReportEvent[ReportEvent["RED_NODE_DOOR_LOCKED"] = 2004] = "RED_NODE_DOOR_LOCKED";
    ReportEvent[ReportEvent["RED_PROGRAM_CHANGED"] = 1006] = "RED_PROGRAM_CHANGED";
    ReportEvent[ReportEvent["RED_NODE_TWO_POINT_CONTROLLER_ON"] = 2010] = "RED_NODE_TWO_POINT_CONTROLLER_ON";
    ReportEvent[ReportEvent["RED_NODE_TWO_POINT_CONTROLLER_OFF"] = 2011] = "RED_NODE_TWO_POINT_CONTROLLER_OFF";
    ReportEvent[ReportEvent["RED_NODE_TWO_POINT_CONTROLLER_SET_POINT_CHANGED"] = 2012] = "RED_NODE_TWO_POINT_CONTROLLER_SET_POINT_CHANGED";
    ReportEvent[ReportEvent["RED_INNER_RANGE_AREA_ARMED"] = 2015] = "RED_INNER_RANGE_AREA_ARMED";
    ReportEvent[ReportEvent["RED_INNER_RANGE_AREA_DISARMED"] = 2016] = "RED_INNER_RANGE_AREA_DISARMED";
    ReportEvent[ReportEvent["RED_INNER_RANGE_AREA_ERROR"] = 2017] = "RED_INNER_RANGE_AREA_ERROR";
    ReportEvent[ReportEvent["RED_INNER_RANGE_DOOR_LOCKED"] = 2018] = "RED_INNER_RANGE_DOOR_LOCKED";
    ReportEvent[ReportEvent["RED_INNER_RANGE_DOOR_UNLOCKED"] = 2019] = "RED_INNER_RANGE_DOOR_UNLOCKED";
    ReportEvent[ReportEvent["RED_INNER_RANGE_DOOR_TOGGLED"] = 2020] = "RED_INNER_RANGE_DOOR_TOGGLED";
    ReportEvent[ReportEvent["RED_INNER_RANGE_DOOR_ERROR"] = 2021] = "RED_INNER_RANGE_DOOR_ERROR";
    ReportEvent[ReportEvent["ACCESS_CONTROL_READER_ONLINE_OFFLINE"] = 2031] = "ACCESS_CONTROL_READER_ONLINE_OFFLINE";
    ReportEvent[ReportEvent["DOORBELL"] = 2041] = "DOORBELL";
    ReportEvent[ReportEvent["INTERCOM_RING"] = 2042] = "INTERCOM_RING";
    ReportEvent[ReportEvent["ELEVATOR_CALLED"] = 2051] = "ELEVATOR_CALLED";
    ReportEvent[ReportEvent["ELEVATOR_CALL_CANCELLED"] = 2052] = "ELEVATOR_CALL_CANCELLED";
    ReportEvent[ReportEvent["ELEVATOR_ARRIVED"] = 2053] = "ELEVATOR_ARRIVED";
    ReportEvent[ReportEvent["ELEVATOR_TIMEOUT"] = 2054] = "ELEVATOR_TIMEOUT";
    ReportEvent[ReportEvent["LICENSE_PLATE_VERIFIED"] = 2060] = "LICENSE_PLATE_VERIFIED";
    ReportEvent[ReportEvent["LICENSE_PLATE_NOT_FOUND"] = 2061] = "LICENSE_PLATE_NOT_FOUND";
    ReportEvent[ReportEvent["ALARM_ACTIVATED"] = 2070] = "ALARM_ACTIVATED";
    ReportEvent[ReportEvent["ALARM_ACK"] = 2071] = "ALARM_ACK";
    ReportEvent[ReportEvent["ENTITY_CREATED"] = 3000] = "ENTITY_CREATED";
    ReportEvent[ReportEvent["ENTITY_DELETED"] = 3001] = "ENTITY_DELETED";
    ReportEvent[ReportEvent["ENTITY_UPDATED"] = 3002] = "ENTITY_UPDATED";
    ReportEvent[ReportEvent["ALARM_CREATED"] = 3003] = "ALARM_CREATED";
    ReportEvent[ReportEvent["ALARM_RESOLVED"] = 3004] = "ALARM_RESOLVED";
    ReportEvent[ReportEvent["ALARM_CLOUD_ACK"] = 3005] = "ALARM_CLOUD_ACK";
    ReportEvent[ReportEvent["REVEALED_PIN"] = 3010] = "REVEALED_PIN";
    ReportEvent[ReportEvent["SENT_PIN_SMS"] = 3011] = "SENT_PIN_SMS";
    ReportEvent[ReportEvent["SENT_PIN_EMAIL"] = 3012] = "SENT_PIN_EMAIL";
    ReportEvent[ReportEvent["REQUESTED_TO_JOIN_PROPERTY"] = 3013] = "REQUESTED_TO_JOIN_PROPERTY";
    ReportEvent[ReportEvent["SENT_SMS"] = 3014] = "SENT_SMS";
    ReportEvent[ReportEvent["SENT_EMAIL"] = 3015] = "SENT_EMAIL";
    ReportEvent[ReportEvent["AUTOMATION_EVENT"] = 3016] = "AUTOMATION_EVENT";
    ReportEvent[ReportEvent["TICKET_INACTIVITY_REMINDER"] = 3017] = "TICKET_INACTIVITY_REMINDER";
    ReportEvent[ReportEvent["TASK_INACTIVITY_REMINDER"] = 3018] = "TASK_INACTIVITY_REMINDER";
    ReportEvent[ReportEvent["TASK_OVERDUE_REMINDER"] = 3019] = "TASK_OVERDUE_REMINDER";
    ReportEvent[ReportEvent["UNDEFINED"] = 99999] = "UNDEFINED";
})(ReportEvent = exports.ReportEvent || (exports.ReportEvent = {}));
var ReportEventGroup;
(function (ReportEventGroup) {
    ReportEventGroup["SECURITY_EVENTS"] = "security_events";
    ReportEventGroup["DOOR_EVENTS"] = "door_events";
    ReportEventGroup["SYSTEM_EVENTS"] = "system_events";
    ReportEventGroup["AUTHORIZATION_EVENTS"] = "authorization_events";
    ReportEventGroup["GENERIC_FLOW_EVENTS"] = "generic_flow_events";
    ReportEventGroup["UNKNOWN_EVENTS"] = "unknown_events";
    ReportEventGroup["INVALID"] = "invalid";
    ReportEventGroup["CHANGE_LOG"] = "change_log";
})(ReportEventGroup = exports.ReportEventGroup || (exports.ReportEventGroup = {}));
function getEventGroup(code) {
    switch (code) {
        case ReportEvent.SECURITY_MEDICAL_ALARM:
        case ReportEvent.SECURITY_PERSONAL_EMERGENCY:
        case ReportEvent.SECURITY_FAIL_TO_REPORT_IN:
        case ReportEvent.SECURITY_FIRE_ALARM:
        case ReportEvent.SECURITY_SMOKE_ALARM:
        case ReportEvent.SECURITY_COMBUSTION_ALARM:
        case ReportEvent.SECURITY_WATER_FLOW_ALARM:
        case ReportEvent.SECURITY_HEAT_ALARM:
        case ReportEvent.SECURITY_PULL_STATION_ALARM:
        case ReportEvent.SECURITY_DUCT_ALARM:
        case ReportEvent.SECURITY_FLAME_ALARM:
        case ReportEvent.SECURITY_NEAR_ALARM:
        case ReportEvent.SECURITY_PANIC_ALARM:
        case ReportEvent.SECURITY_DURESS_PANIC_ALARM:
        case ReportEvent.SECURITY_SILENT_PANIC_ALARM:
        case ReportEvent.SECURITY_AUDIBLE_PANIC_ALARM:
        case ReportEvent.SECURITY_DURESS_ACCESS_GRANTED_ALARM:
        case ReportEvent.SECURITY_DURESS_EGRESS_GRANTED_ALARM:
        case ReportEvent.SECURITY_BURGLARY_ALARM:
        case ReportEvent.SECURITY_PERIMETER_ALARM:
        case ReportEvent.SECURITY_INTERIOR_ALARM:
        case ReportEvent.SECURITY_24_HOUR_SAFE_ALARM:
        case ReportEvent.SECURITY_ENTRY_EXIT_ALARM:
        case ReportEvent.SECURITY_DAY_NIGHT_ALARM:
        case ReportEvent.SECURITY_OUTDOOR_ALARM:
        case ReportEvent.SECURITY_TAMPER_ALARM:
        case ReportEvent.SECURITY_NEAR_ALARM_:
        case ReportEvent.SECURITY_INTRUSION_VERIFIER:
        case ReportEvent.SECURITY_GENERAL_ALARM:
        case ReportEvent.SECURITY_POLLING_LOOP_OPEN:
        case ReportEvent.SECURITY_ZONE_TROUBLE:
        case ReportEvent.SECURITY_EXPANSION_MODULE_FAILURE:
        case ReportEvent.SECURITY_ZONE_TAMPER:
        case ReportEvent.SECURITY_EXPANSION_MODULE_TAMPER:
        case ReportEvent.SECURITY_SILENT_BURGLARY:
        case ReportEvent.SECURITY_SENSOR_SUPERVISION_FAILURE:
        case ReportEvent.SECURITY_24_HOUR_NON_BURGLARY:
        case ReportEvent.SECURITY_GAS_DETECTED:
        case ReportEvent.SECURITY_REFRIGERATION:
        case ReportEvent.SECURITY_LOSS_OF_HEAT:
        case ReportEvent.SECURITY_WATER_LEAKAGE:
        case ReportEvent.SECURITY_FOIL_BREAK:
        case ReportEvent.SECURITY_DAY_TROUBLE:
        case ReportEvent.SECURITY_LOW_BOTTLED_GAS_LEVEL:
        case ReportEvent.SECURITY_HIGH_TEMP:
        case ReportEvent.SECURITY_LOW_TEMP:
        case ReportEvent.SECURITY_LOSS_OF_AIR_FLOW:
        case ReportEvent.SECURITY_CARBON_MONOXIDE_DETECTED:
        case ReportEvent.SECURITY_TANK_LEVEL:
        case ReportEvent.SECURITY_SYSTEM_TROUBLE:
        case ReportEvent.SECURITY_PRIMARY_AC_LOSS:
        case ReportEvent.SECURITY_LOW_SYSTEM_BATTERY:
        case ReportEvent.SECURITY_SOUNDER_RELAY_TROUBLE:
        case ReportEvent.SECURITY_BELL_1_TROUBLE:
        case ReportEvent.SECURITY_ATS_COMMUNICATION_TROUBLE:
        case ReportEvent.SECURITY_PROGRAM_CHANGED:
        case ReportEvent.SECURITY_ARMED_DISARMED:
        case ReportEvent.SECURITY_FAILED_TO_ARM:
        case ReportEvent.SECURITY_FAILED_TO_DISARM:
        case ReportEvent.SECURITY_PARTIAL_ARMED_DISARMED:
        case ReportEvent.SECURITY_TROUBLE_ACK:
        case ReportEvent.REVEALED_PIN:
        case ReportEvent.SENT_PIN_SMS:
        case ReportEvent.SENT_PIN_EMAIL: {
            return ReportEventGroup.SECURITY_EVENTS;
        }
        case ReportEvent.ALARM_ACTIVATED:
        case ReportEvent.ALARM_ACK:
        case ReportEvent.RED_PROGRAM_CHANGED:
        case ReportEvent.ADDITIONAL_USER_EVENTS:
        case ReportEvent.USER_ADDED:
        case ReportEvent.USER_REMOVED:
        case ReportEvent.USER_MODIFIED:
        case ReportEvent.RESERVED_1104:
        case ReportEvent.USER_LOGICAL_KEY_ADDED:
        case ReportEvent.USER_LOGICAL_KEY_REMOVED:
        case ReportEvent.USER_LOGICAL_KEY_MODIFIED:
        case ReportEvent.CLOUD_EVENTS:
        case ReportEvent.CLOUD_SETTINGS_CHANGED:
        case ReportEvent.SUCCESSFULLY_CONNECTED_TO_CLOUD:
        case ReportEvent.CLOUD_CONNECTION_CLOSED:
        case ReportEvent.CLOUD_CONNECTION_ERROR:
        case ReportEvent.CLOUD_CONFIGURATION_MISSING:
        case ReportEvent.CLOUD_CONNECTION_OFFLINE:
        case ReportEvent.CLOUD_TOKEN_PUBLIC_KEYS_URL_CHANGED:
        case ReportEvent.REMOTE_REPORTING_SETTINGS_CHANGED:
        case ReportEvent.UNIT_EVENTS:
        case ReportEvent.UNIT_CREATED:
        case ReportEvent.UNIT_SETTINGS_CHANGED:
        case ReportEvent.UNIT_DELETED:
        case ReportEvent.USER_ASSIGNED_TO_UNIT:
        case ReportEvent.USER_UNASSIGNED_FROM_UNIT:
        case ReportEvent.SENT_SMS:
        case ReportEvent.SENT_EMAIL:
        case ReportEvent.SW_UPDATE_STARTED: {
            return ReportEventGroup.SYSTEM_EVENTS;
        }
        case ReportEvent.LOCAL_USER_LOGIN_SUCCESSFUL:
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_WRONG_PASSWORD:
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_DOES_NOT_HAVE_PASSWORD_ON_A_DATABASE:
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_UNKNOWN_USER:
        case ReportEvent.LOCAL_USER_LOGIN_INPUT_DISABLED_BECAUSE_OF_INVALID_ATTEMPTS:
        case ReportEvent.CARD_AUTHORIZATION_FAILURE_CARD_NOT_FOUND:
        case ReportEvent.CARD_AUTHORIZATION_FAILURE_INVALID_PIN:
        case ReportEvent.PIN_USER_AUTHORIZATION_FAILURE_INVALID_PIN:
        case ReportEvent.CARD_AUTHROIZATION_SUCCESSFUL:
        case ReportEvent.PIN_USER_AUTHROIZATION_SUCCESSFUL:
        case ReportEvent.LICENSE_PLATE_VERIFIED:
        case ReportEvent.LICENSE_PLATE_NOT_FOUND: {
            return ReportEventGroup.AUTHORIZATION_EVENTS;
        }
        case ReportEvent.RED_NODE_DOOR_OPENED:
        case ReportEvent.RED_NODE_DOOR_CLOSED:
        case ReportEvent.RED_NODE_DOOR_UNLOCKED:
        case ReportEvent.RED_NODE_DOOR_LOCKED:
        case ReportEvent.RED_INNER_RANGE_DOOR_LOCKED:
        case ReportEvent.RED_INNER_RANGE_DOOR_UNLOCKED:
        case ReportEvent.RED_INNER_RANGE_DOOR_TOGGLED:
        case ReportEvent.RED_INNER_RANGE_DOOR_ERROR:
        case ReportEvent.ACCESS_CONTROL_READER_ONLINE_OFFLINE:
        case ReportEvent.DOORBELL:
        case ReportEvent.INTERCOM_RING:
        case ReportEvent.ELEVATOR_CALLED:
        case ReportEvent.ELEVATOR_CALL_CANCELLED:
        case ReportEvent.ELEVATOR_ARRIVED:
        case ReportEvent.ELEVATOR_TIMEOUT: {
            return ReportEventGroup.DOOR_EVENTS;
        }
        case ReportEvent.RED_EVENT:
        case ReportEvent.RED_NODE_TWO_POINT_CONTROLLER_ON:
        case ReportEvent.RED_NODE_TWO_POINT_CONTROLLER_OFF:
        case ReportEvent.RED_NODE_TWO_POINT_CONTROLLER_SET_POINT_CHANGED:
        case ReportEvent.RED_INNER_RANGE_AREA_ARMED:
        case ReportEvent.RED_INNER_RANGE_AREA_DISARMED:
        case ReportEvent.RED_INNER_RANGE_AREA_ERROR:
            {
                return ReportEventGroup.GENERIC_FLOW_EVENTS;
            }
        case ReportEvent.ENTITY_CREATED:
        case ReportEvent.ENTITY_UPDATED:
        case ReportEvent.ENTITY_DELETED:
        case ReportEvent.ALARM_CREATED:
        case ReportEvent.ALARM_RESOLVED:
        case ReportEvent.ALARM_CLOUD_ACK:
        case ReportEvent.AUTOMATION_EVENT:
        case ReportEvent.TICKET_INACTIVITY_REMINDER:
        case ReportEvent.TASK_INACTIVITY_REMINDER:
        case ReportEvent.TASK_OVERDUE_REMINDER:
        case ReportEvent.REQUESTED_TO_JOIN_PROPERTY: {
            return ReportEventGroup.CHANGE_LOG;
        }
        case ReportEvent.UNDEFINED: {
            return ReportEventGroup.UNKNOWN_EVENTS;
        }
        default: {
            return ReportEventGroup.INVALID;
        }
    }
}
exports.getEventGroup = getEventGroup;
var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
function getLogLevels() {
    return Object.keys(LogLevel);
}
exports.getLogLevels = getLogLevels;
function getLogLevel(code) {
    switch (code) {
        case ReportEvent.SECURITY_PROGRAM_CHANGED:
        case ReportEvent.SECURITY_FAILED_TO_ARM:
        case ReportEvent.SECURITY_FAILED_TO_DISARM:
        case ReportEvent.ADDITIONAL_USER_EVENTS:
        case ReportEvent.USER_ADDED:
        case ReportEvent.USER_REMOVED:
        case ReportEvent.USER_MODIFIED:
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_WRONG_PASSWORD:
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_DOES_NOT_HAVE_PASSWORD_ON_A_DATABASE:
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_UNKNOWN_USER:
        case ReportEvent.CARD_AUTHORIZATION_FAILURE_CARD_NOT_FOUND:
        case ReportEvent.CARD_AUTHORIZATION_FAILURE_INVALID_PIN:
        case ReportEvent.PIN_USER_AUTHORIZATION_FAILURE_INVALID_PIN:
        case ReportEvent.SW_UPDATE_STARTED:
        case ReportEvent.RED_INNER_RANGE_AREA_ERROR:
        case ReportEvent.RED_INNER_RANGE_DOOR_ERROR:
        case ReportEvent.LICENSE_PLATE_NOT_FOUND:
        case ReportEvent.REVEALED_PIN:
        case ReportEvent.SENT_PIN_EMAIL:
        case ReportEvent.REQUESTED_TO_JOIN_PROPERTY:
        case ReportEvent.SENT_PIN_SMS:
            return LogLevel.WARNING;
        case ReportEvent.SECURITY_MEDICAL_ALARM:
        case ReportEvent.SECURITY_PERSONAL_EMERGENCY:
        case ReportEvent.SECURITY_FAIL_TO_REPORT_IN:
        case ReportEvent.SECURITY_FIRE_ALARM:
        case ReportEvent.SECURITY_SMOKE_ALARM:
        case ReportEvent.SECURITY_COMBUSTION_ALARM:
        case ReportEvent.SECURITY_WATER_FLOW_ALARM:
        case ReportEvent.SECURITY_HEAT_ALARM:
        case ReportEvent.SECURITY_PULL_STATION_ALARM:
        case ReportEvent.SECURITY_DUCT_ALARM:
        case ReportEvent.SECURITY_FLAME_ALARM:
        case ReportEvent.SECURITY_NEAR_ALARM:
        case ReportEvent.SECURITY_PANIC_ALARM:
        case ReportEvent.SECURITY_DURESS_PANIC_ALARM:
        case ReportEvent.SECURITY_SILENT_PANIC_ALARM:
        case ReportEvent.SECURITY_AUDIBLE_PANIC_ALARM:
        case ReportEvent.SECURITY_DURESS_ACCESS_GRANTED_ALARM:
        case ReportEvent.SECURITY_DURESS_EGRESS_GRANTED_ALARM:
        case ReportEvent.SECURITY_BURGLARY_ALARM:
        case ReportEvent.SECURITY_PERIMETER_ALARM:
        case ReportEvent.SECURITY_INTERIOR_ALARM:
        case ReportEvent.SECURITY_24_HOUR_SAFE_ALARM:
        case ReportEvent.SECURITY_ENTRY_EXIT_ALARM:
        case ReportEvent.SECURITY_DAY_NIGHT_ALARM:
        case ReportEvent.SECURITY_OUTDOOR_ALARM:
        case ReportEvent.SECURITY_TAMPER_ALARM:
        case ReportEvent.SECURITY_NEAR_ALARM_:
        case ReportEvent.SECURITY_INTRUSION_VERIFIER:
        case ReportEvent.SECURITY_GENERAL_ALARM:
        case ReportEvent.SECURITY_POLLING_LOOP_OPEN:
        case ReportEvent.SECURITY_ZONE_TROUBLE:
        case ReportEvent.SECURITY_EXPANSION_MODULE_FAILURE:
        case ReportEvent.SECURITY_ZONE_TAMPER:
        case ReportEvent.SECURITY_EXPANSION_MODULE_TAMPER:
        case ReportEvent.SECURITY_SILENT_BURGLARY:
        case ReportEvent.SECURITY_SENSOR_SUPERVISION_FAILURE:
        case ReportEvent.SECURITY_24_HOUR_NON_BURGLARY:
        case ReportEvent.SECURITY_GAS_DETECTED:
        case ReportEvent.SECURITY_REFRIGERATION:
        case ReportEvent.SECURITY_LOSS_OF_HEAT:
        case ReportEvent.SECURITY_WATER_LEAKAGE:
        case ReportEvent.SECURITY_FOIL_BREAK:
        case ReportEvent.SECURITY_DAY_TROUBLE:
        case ReportEvent.SECURITY_LOW_BOTTLED_GAS_LEVEL:
        case ReportEvent.SECURITY_HIGH_TEMP:
        case ReportEvent.SECURITY_LOW_TEMP:
        case ReportEvent.SECURITY_LOSS_OF_AIR_FLOW:
        case ReportEvent.SECURITY_CARBON_MONOXIDE_DETECTED:
        case ReportEvent.SECURITY_TANK_LEVEL:
        case ReportEvent.SECURITY_SYSTEM_TROUBLE:
        case ReportEvent.SECURITY_PRIMARY_AC_LOSS:
        case ReportEvent.SECURITY_LOW_SYSTEM_BATTERY:
        case ReportEvent.SECURITY_SOUNDER_RELAY_TROUBLE:
        case ReportEvent.SECURITY_BELL_1_TROUBLE:
        case ReportEvent.SECURITY_ATS_COMMUNICATION_TROUBLE:
        case ReportEvent.ALARM_ACTIVATED:
            {
                return LogLevel.ERROR;
            }
        default:
            return LogLevel.INFO;
    }
}
exports.getLogLevel = getLogLevel;
function getEventMessage(code) {
    switch (code) {
        case ReportEvent.RED_INNER_RANGE_AREA_ARMED:
            return 'Area armed';
        case ReportEvent.RED_INNER_RANGE_AREA_DISARMED:
            return 'Area disarmed';
        case ReportEvent.RED_INNER_RANGE_AREA_ERROR:
            return 'Unknown error';
        case ReportEvent.RED_INNER_RANGE_DOOR_LOCKED:
            return 'Door locked';
        case ReportEvent.RED_INNER_RANGE_DOOR_UNLOCKED:
            return 'Door unlocked';
        case ReportEvent.RED_INNER_RANGE_DOOR_TOGGLED:
            return 'Door toggled';
        case ReportEvent.RED_INNER_RANGE_DOOR_ERROR:
            return 'Unknown error';
        case ReportEvent.SECURITY_MEDICAL_ALARM:
            return 'Medical Alarm';
        case ReportEvent.SECURITY_PERSONAL_EMERGENCY:
            return 'Personal Emergency';
        case ReportEvent.SECURITY_FAIL_TO_REPORT_IN:
            return 'Fail to report in';
        case ReportEvent.SECURITY_FIRE_ALARM:
            return 'Fire Alarm';
        case ReportEvent.SECURITY_SMOKE_ALARM:
            return 'Smoke Alarm';
        case ReportEvent.SECURITY_COMBUSTION_ALARM:
            return 'Combustion Alarm';
        case ReportEvent.SECURITY_WATER_FLOW_ALARM:
            return 'Water flow Alarm';
        case ReportEvent.SECURITY_HEAT_ALARM:
            return 'Heat Alarm';
        case ReportEvent.SECURITY_PULL_STATION_ALARM:
            return 'Pull Station Alarm';
        case ReportEvent.SECURITY_DUCT_ALARM:
            return 'Duct Alarm';
        case ReportEvent.SECURITY_FLAME_ALARM:
            return 'Flame Alarm';
        case ReportEvent.SECURITY_NEAR_ALARM:
            return 'Near Alarm';
        case ReportEvent.SECURITY_PANIC_ALARM:
            return 'Panic Alarm';
        case ReportEvent.SECURITY_DURESS_PANIC_ALARM:
            return 'Duress Panic Alarm';
        case ReportEvent.SECURITY_SILENT_PANIC_ALARM:
            return 'Silent Panic Alarm';
        case ReportEvent.SECURITY_AUDIBLE_PANIC_ALARM:
            return 'Audible Panic Alarm';
        case ReportEvent.SECURITY_DURESS_ACCESS_GRANTED_ALARM:
            return 'Duress - Access granted Alarm';
        case ReportEvent.SECURITY_DURESS_EGRESS_GRANTED_ALARM:
            return 'Duress - Egress granted Alarm';
        case ReportEvent.SECURITY_BURGLARY_ALARM:
            return 'Burglary Alarm';
        case ReportEvent.SECURITY_PERIMETER_ALARM:
            return 'Perimeter Alarm';
        case ReportEvent.SECURITY_INTERIOR_ALARM:
            return 'Interior Alarm';
        case ReportEvent.SECURITY_24_HOUR_SAFE_ALARM:
            return '24 Hour (Safe) Alarm';
        case ReportEvent.SECURITY_ENTRY_EXIT_ALARM:
            return 'Entry/Exit Alarm';
        case ReportEvent.SECURITY_DAY_NIGHT_ALARM:
            return 'Day/night Alarm';
        case ReportEvent.SECURITY_OUTDOOR_ALARM:
            return 'Outdoor Alarm';
        case ReportEvent.SECURITY_TAMPER_ALARM:
            return 'Tamper Alarm';
        case ReportEvent.SECURITY_NEAR_ALARM_:
            return 'Near alarm ';
        case ReportEvent.SECURITY_INTRUSION_VERIFIER:
            return 'Intrusion Verifier';
        case ReportEvent.SECURITY_GENERAL_ALARM:
            return 'General Alarm';
        case ReportEvent.SECURITY_POLLING_LOOP_OPEN:
            return 'Polling loop open';
        case ReportEvent.SECURITY_ZONE_TROUBLE:
            return 'Zone trouble';
        case ReportEvent.SECURITY_EXPANSION_MODULE_FAILURE:
            return 'Expansion module failure';
        case ReportEvent.SECURITY_ZONE_TAMPER:
            return 'Zone tamper';
        case ReportEvent.SECURITY_EXPANSION_MODULE_TAMPER:
            return 'Expansion module tamper';
        case ReportEvent.SECURITY_SILENT_BURGLARY:
            return 'Silent Burglary';
        case ReportEvent.SECURITY_SENSOR_SUPERVISION_FAILURE:
            return 'Sensor Supervision Failure';
        case ReportEvent.SECURITY_24_HOUR_NON_BURGLARY:
            return '24 Hour Non-Burglary';
        case ReportEvent.SECURITY_GAS_DETECTED:
            return 'Gas detected';
        case ReportEvent.SECURITY_REFRIGERATION:
            return 'Refrigeration';
        case ReportEvent.SECURITY_LOSS_OF_HEAT:
            return 'Loss of heat';
        case ReportEvent.SECURITY_WATER_LEAKAGE:
            return 'Water Leakage';
        case ReportEvent.SECURITY_FOIL_BREAK:
            return 'Foil Break';
        case ReportEvent.SECURITY_DAY_TROUBLE:
            return 'Day Trouble';
        case ReportEvent.SECURITY_LOW_BOTTLED_GAS_LEVEL:
            return 'Low bottled gas level';
        case ReportEvent.SECURITY_HIGH_TEMP:
            return 'High temp';
        case ReportEvent.SECURITY_LOW_TEMP:
            return 'Low temp';
        case ReportEvent.SECURITY_LOSS_OF_AIR_FLOW:
            return 'Loss of air flow';
        case ReportEvent.SECURITY_CARBON_MONOXIDE_DETECTED:
            return 'Carbon Monoxide detected';
        case ReportEvent.SECURITY_TANK_LEVEL:
            return 'Tank level';
        case ReportEvent.SECURITY_SYSTEM_TROUBLE:
            return 'System Trouble';
        case ReportEvent.SECURITY_PRIMARY_AC_LOSS:
            return 'Primary AC Loss';
        case ReportEvent.SECURITY_LOW_SYSTEM_BATTERY:
            return 'Low system battery';
        case ReportEvent.SECURITY_SOUNDER_RELAY_TROUBLE:
            return 'Sounder/Relay Trouble';
        case ReportEvent.SECURITY_BELL_1_TROUBLE:
            return 'Bell 1 Trouble';
        case ReportEvent.SECURITY_ATS_COMMUNICATION_TROUBLE:
            return 'ATS Communication trouble';
        case ReportEvent.SECURITY_TROUBLE_ACK:
            return 'Trouble acknowledged';
        case ReportEvent.ADDITIONAL_USER_EVENTS:
            return 'User Event';
        case ReportEvent.USER_ADDED:
            return 'User added';
        case ReportEvent.USER_REMOVED:
            return 'User removed';
        case ReportEvent.USER_MODIFIED:
            return 'User modified';
        case ReportEvent.RESERVED_1104:
            return 'Reserved';
        case ReportEvent.LOCAL_USER_LOGIN_SUCCESSFUL:
            return 'Local user login successful';
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_WRONG_PASSWORD:
            return 'Local user login via web interface failure - wrong password';
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_DOES_NOT_HAVE_PASSWORD_ON_A_DATABASE:
            return 'Local user login via web interface failure - does not have password on a database';
        case ReportEvent.LOCAL_USER_LOGIN_VIA_WEB_INTERFACE_FAILURE_UNKNOWN_USER:
            return 'Local user login via web interface failure - unknown user';
        case ReportEvent.LOCAL_USER_LOGIN_INPUT_DISABLED_BECAUSE_OF_INVALID_ATTEMPTS:
            return 'Local user login input disabled because of invalid attempts';
        case ReportEvent.CARD_AUTHORIZATION_FAILURE_CARD_NOT_FOUND:
            return 'Card authorization failure - card not found';
        case ReportEvent.CARD_AUTHORIZATION_FAILURE_INVALID_PIN:
            return 'Card authorization failure - invaid pin';
        case ReportEvent.PIN_USER_AUTHORIZATION_FAILURE_INVALID_PIN:
            return 'Pin user authorization failure - invalid pin';
        case ReportEvent.CARD_AUTHROIZATION_SUCCESSFUL:
            return 'Card authroization successful';
        case ReportEvent.PIN_USER_AUTHROIZATION_SUCCESSFUL:
            return 'Pin user authroization successful';
        case ReportEvent.USER_LOGICAL_KEY_ADDED:
            return 'Card created';
        case ReportEvent.USER_LOGICAL_KEY_REMOVED:
            return 'Card removed';
        case ReportEvent.USER_LOGICAL_KEY_MODIFIED:
            return 'Card modified';
        case ReportEvent.CLOUD_EVENTS:
            return 'Cloud event';
        case ReportEvent.CLOUD_SETTINGS_CHANGED:
            return 'Cloud settings changed';
        case ReportEvent.SUCCESSFULLY_CONNECTED_TO_CLOUD:
            return 'Successfully connected to cloud';
        case ReportEvent.CLOUD_CONNECTION_CLOSED:
            return 'Cloud connection closed';
        case ReportEvent.CLOUD_CONNECTION_ERROR:
            return 'Cloud connection error';
        case ReportEvent.CLOUD_CONFIGURATION_MISSING:
            return 'Cloud configuration error';
        case ReportEvent.CLOUD_CONNECTION_OFFLINE:
            return 'Cloud connection offline';
        case ReportEvent.CLOUD_TOKEN_PUBLIC_KEYS_URL_CHANGED:
            return 'Cloud token public keys URL changed';
        case ReportEvent.REMOTE_REPORTING_SETTINGS_CHANGED:
            return 'Remote report settings changed';
        case ReportEvent.UNIT_EVENTS:
            return 'Unit event';
        case ReportEvent.UNIT_CREATED:
            return 'Unit created';
        case ReportEvent.UNIT_SETTINGS_CHANGED:
            return 'Unit settings changed';
        case ReportEvent.UNIT_DELETED:
            return 'Unit deleted';
        case ReportEvent.USER_ASSIGNED_TO_UNIT:
            return 'User assigned to unit';
        case ReportEvent.USER_UNASSIGNED_FROM_UNIT:
            return 'User assigned from unit';
        case ReportEvent.RED_PROGRAM_CHANGED:
            return 'Flow prgram changed';
        case ReportEvent.RED_EVENT:
            return 'Red event';
        case ReportEvent.RED_NODE_DOOR_OPENED:
            return 'Door opened';
        case ReportEvent.RED_NODE_DOOR_CLOSED:
            return 'Door closed';
        case ReportEvent.RED_NODE_DOOR_UNLOCKED:
            return 'Door unlocked';
        case ReportEvent.RED_NODE_DOOR_LOCKED:
            return 'Door locked';
        case ReportEvent.RED_NODE_TWO_POINT_CONTROLLER_ON:
            return 'Controller switched on';
        case ReportEvent.RED_NODE_TWO_POINT_CONTROLLER_OFF:
            return 'Controller switched off';
        case ReportEvent.RED_NODE_TWO_POINT_CONTROLLER_SET_POINT_CHANGED:
            return 'Controller set point changed';
        case ReportEvent.ALARM_ACTIVATED:
            return 'Alarm activated';
        case ReportEvent.ALARM_ACK:
            return 'Alarm acknowledged';
        case ReportEvent.ACCESS_CONTROL_READER_ONLINE_OFFLINE:
            return 'Access control reader online/offline';
        case ReportEvent.DOORBELL:
            return 'Doorbell';
        case ReportEvent.INTERCOM_RING:
            return 'Intercom ring';
        case ReportEvent.ELEVATOR_ARRIVED:
            return 'Elevator arrived';
        case ReportEvent.ELEVATOR_CALLED:
            return 'Elevator called';
        case ReportEvent.ELEVATOR_CALL_CANCELLED:
            return 'Elevator call cancelled';
        case ReportEvent.ELEVATOR_TIMEOUT:
            return 'Elevator call timeout';
        case ReportEvent.SECURITY_PARTIAL_ARMED_DISARMED:
            return 'Area partial armed/disarmed';
        case ReportEvent.SECURITY_ARMED_DISARMED:
            return 'Area armed/disarmed';
        case ReportEvent.SECURITY_FAILED_TO_ARM:
            return 'Failed to arm';
        case ReportEvent.SECURITY_FAILED_TO_DISARM:
            return 'Failed to disarm';
        case ReportEvent.SECURITY_PROGRAM_CHANGED:
            return 'Security program changed';
        case ReportEvent.SW_UPDATE_STARTED:
            return 'Software update started';
        case ReportEvent.LICENSE_PLATE_NOT_FOUND:
            return 'License plate not found';
        case ReportEvent.LICENSE_PLATE_VERIFIED:
            return 'License plate verified';
        case ReportEvent.ENTITY_CREATED:
            return 'Created';
        case ReportEvent.ENTITY_DELETED:
            return 'Deleted';
        case ReportEvent.ENTITY_UPDATED:
            return 'Updated';
        case ReportEvent.ALARM_CLOUD_ACK:
            return 'Alarm Acknowledged';
        case ReportEvent.ALARM_CREATED:
            return 'Alarm created';
        case ReportEvent.ALARM_RESOLVED:
            return 'Alarm resolved';
        case ReportEvent.REVEALED_PIN:
            return 'Revealed pin';
        case ReportEvent.SENT_PIN_EMAIL:
            return 'Sent pin email';
        case ReportEvent.SENT_PIN_SMS:
            return 'Sent pin SMS';
        case ReportEvent.REQUESTED_TO_JOIN_PROPERTY:
            return 'Requested to join property';
        case ReportEvent.SENT_SMS:
            return 'Sent SMS';
        case ReportEvent.SENT_EMAIL:
            return 'Sent email';
        case ReportEvent.AUTOMATION_EVENT:
            return 'Automation event';
        case ReportEvent.TICKET_INACTIVITY_REMINDER:
            return 'Ticket inactivity reminder';
        case ReportEvent.TASK_INACTIVITY_REMINDER:
            return 'Task inactivity reminder';
        case ReportEvent.TASK_OVERDUE_REMINDER:
            return 'Task overdue reminder';
        case ReportEvent.UNDEFINED:
            return 'Unknown';
        default:
            return 'Invalid';
    }
}
exports.getEventMessage = getEventMessage;
//# sourceMappingURL=report-events.js.map